









































import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { TranslateResult } from 'vue-i18n'
import { Agency } from '@/api/Agency/agency.interface'
import DrawerItems from './DrawerItems.vue'
import { Services } from '@/utils/services.enum'
import { debounce } from 'debounce'
import { Roles } from '@/plugins/permissions'

interface ListItem {
  name: TranslateResult
  icon: string
  children?: ListItem[]
  to?: string | { name: string }
  roles?: string[]
  notShow?: boolean
}

export default Vue.extend({
  components: {
    appDrawerItems: DrawerItems,
  },
  data() {
    return {
      // image: new FileReader().result,
      colorsDialog: false,
      search: '',
      filteredItems: [] as ListItem[],
      loading: false,
    }
  },
  computed: {
    ...mapState(['barColor', 'miniVariant', 'profile']),
    agency(): Agency | {} {
      const agency = this.$store.getters.agency as Agency
      if (agency) {
        return agency
      }
      return {}
    },
    items(): ListItem[] {
      return [
        {
          name: this.$t('nauta.nauta'),
          icon: 'mdi-at',
          notShow:
            !this.profile ||
            this.profile.parent ||
            !this.profile.services ||
            !this.profile.services.includes(Services.Nauta),
          children: [
            {
              name: this.$t('nauta.create'),
              icon: 'mdi-plus',
              to: { name: 'nauta.create' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('nauta.list'),
              icon: 'mdi-format-list-bulleted',
              to: { name: 'nauta.list' },
              roles: ['ADMIN', 'AGENT'],
            },
          ],
        },
        {
          name: this.$t('rental.cars'),
          icon: 'mdi-car',
          notShow: !this.profile.services.includes(Services.RentalCar),
          children: [
            {
              name: this.$t('rental.contracts'),
              icon: 'mdi-book-open-page-variant',
              to: { name: 'rental.contracts' },
            },
            {
              name: this.$t('rental.shared_contracts'),
              icon: 'mdi-book-open-page-variant-outline',
              to: { name: 'rental.shared_contracts' },
            },
            {
              name: this.$t('rental.contract_prices'),
              icon: 'mdi-cash-usd',
              to: { name: 'rental.contract_prices' },
            },
            {
              name: this.$t('rental.shared_prices'),
              icon: 'mdi-share-variant',
              to: { name: 'rental.shared_prices' },
            },
            {
              name: this.$t('rental.bookings'),
              icon: 'mdi-format-list-bulleted',
              to: { name: 'rental.bookings' },
            },
            {
              name: this.$t('rental.agencies'),
              icon: 'mdi-domain',
              to: { name: 'rental.agencies' },
            },
            {
              name: this.$t('rental.clients'),
              icon: 'mdi-account-box-multiple',
              to: { name: 'rental.clients' },
            },
            {
              name: this.$t('rental.categories'),
              icon: 'mdi-shape',
              to: { name: 'rental.categories' },
            },
            {
              name: this.$t('rental.offices'),
              icon: 'mdi-office-building-marker',
              to: { name: 'rental.offices' },
            },
            {
              name: this.$t('rental.seasons'),
              icon: 'mdi-calendar-month',
              to: { name: 'rental.seasons' },
            },
            {
              name: this.$t('rental.price_config'),
              icon: 'mdi-cogs',
              to: { name: 'rental.price_config' },
              roles: [Roles.ADMIN],
            },
          ],
        },
        {
          name: this.$t('topup.topup'),
          icon: 'mdi-cellphone-iphone',
          notShow:
            !this.profile ||
            !this.profile.services ||
            !this.profile.services.includes(Services.Topup),
          children: [
            {
              name: this.$t('topup.create'),
              icon: 'mdi-plus',
              to: { name: 'topup.create' },
              roles: ['ADMIN', 'AGENT', 'EMPLOYEE'],
            },
            {
              name: this.$t('topup.list'),
              icon: 'mdi-format-list-bulleted',
              to: { name: 'topup.list' },
              roles: ['ADMIN', 'AGENT', 'INTEGRATION', 'EMPLOYEE'],
            },
            {
              name: this.$t('topup.credit-transfer'),
              icon: 'mdi-bank-transfer',
              to: { name: 'topup.credit-transfer' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('credit'),
              icon: 'mdi-credit-card',
              to: { name: 'topup.credit' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('reports'),
              icon: 'mdi-file-chart',
              to: { name: 'topup.reports' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('products'),
              icon: 'mdi-format-list-numbered',
              to: { name: 'topup.products' },
              notShow: !(this.profile.is_superuser || this.$p.isMaikel),
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('topup.deals'),
              icon: 'mdi-decagram',
              to: { name: 'topup.deals' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('integrations'),
              icon: 'mdi-set-center',
              to: { name: 'topup.integrations' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('platform-price'),
              icon: 'mdi-cash-multiple',
              to: { name: 'topup.platform-price' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('topup.balance_transfer'),
              icon: 'mdi-transfer',
              to: { name: 'topup.balance_transfer' },
              roles: [Roles.ADMIN, Roles.AGENT],
              notShow: this.$p.isAdmin && !this.$p.canManageTransferTopups,
            },
            {
              name: this.$t('topup.start_deal'),
              icon: 'mdi-gesture-tap-button',
              to: { name: 'topup.start_deal' },
              roles: [Roles.ADMIN],
              notShow: !(this.profile.is_superuser || this.$p.isMaikel),
            },
            {
              name: this.$t('transactions.transactions'),
              icon: 'mdi-bank-transfer',
              children: [
                {
                  name: this.$t('topup.credit_transactions'),
                  icon: 'mdi-credit-card',
                  to: { name: 'topup.credit_transactions' },
                },
                {
                  name: this.$t('topup.balance_transactions'),
                  icon: 'mdi-cash',
                  to: { name: 'topup.balance_transactions' },
                },
                {
                  name: this.$t('topup.provider_credit_transactions'),
                  icon: 'mdi-source-branch',
                  to: { name: 'topup.provider_credit_transactions' },
                  roles: [Roles.ADMIN],
                },
                {
                  name: this.$t('topup.agency_transactions'),
                  icon: 'mdi-domain',
                  to: { name: 'topup.agency_transactions' },
                  roles: [Roles.ADMIN],
                },
              ],
            },
          ],
        },
        {
          name: this.$t('remittances'),
          icon: 'mdi-currency-usd',
          notShow:
            !this.profile ||
            !this.profile.services ||
            !this.profile.services.includes(Services.Remittance),
          children: [
            {
              name:
                this.$t('create-remittance') +
                ' CUP, USD ' +
                this.$t('and') +
                ' EUR',
              icon: 'mdi-plus',
              to: { name: 'create-remittance' },
              roles: ['ADMIN', 'EMPLOYEE', 'ACCOUNTANT'],
            },
            {
              name: this.$t('create-remittance-mlc'),
              icon: 'mdi-plus',
              to: { name: 'create-remittance-mlc' },
              roles: ['ADMIN', 'EMPLOYEE', 'ACCOUNTANT'],
            },
            {
              name: this.$t('create-remittance-mlx'),
              icon: 'mdi-plus',
              to: { name: 'create-remittance-mlx' },
              roles: ['ADMIN', 'EMPLOYEE', 'ACCOUNTANT'],
            },
            {
              name: this.$t('create-remittance-ust'),
              icon: 'mdi-plus',
              to: { name: 'create-remittance-ust' },
              roles: ['ADMIN', 'EMPLOYEE', 'ACCOUNTANT'],
            },
            {
              name: this.$t('consult-remittance-price'),
              icon: 'mdi-help-rhombus',
              to: { name: 'consult-remittance-price' },
              roles: ['ADMIN', 'EMPLOYEE', 'ACCOUNTANT'],
            },
            {
              name: this.$t('remittances-list'),
              icon: 'mdi-format-list-bulleted',
              to: { name: 'remittances-list' },
            },
            {
              name: this.$t('invoices'),
              icon: 'mdi-receipt',
              to: { name: 'remittance-invoices' },
              roles: [Roles.ADMIN, Roles.EMPLOYEE],
            },
            {
              name: this.$t('tariff'),
              icon: 'mdi-home-currency-usd',
              to: { name: 'tariff' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('messengers'),
              icon: 'mdi-message',
              to: { name: 'messengers' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('wholesaler'),
              icon: 'mdi-store',
              to: { name: 'remittance.wholesaler' },
              roles: ['ADMIN', 'WHOLESALER'],
            },
            {
              name: this.$t('remittance.auto_assign'),
              icon: 'mdi-clipboard-text',
              to: { name: 'remittance.auto_assign' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('remittance.auto_up'),
              icon: 'mdi-truck-delivery',
              to: { name: 'remittance.auto_up' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('remittance.platform-price'),
              icon: 'mdi-cash-multiple',
              to: { name: 'remittance.platform-price' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('remittance.currency_fee'),
              icon: 'mdi-currency-usd',
              to: { name: 'remittance.currency-fee' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('remittance.reports'),
              icon: 'mdi-poll',
              to: { name: 'remittance.reports' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('remittance.balances'),
              icon: 'mdi-folder',
              roles: [Roles.ADMIN],
              children: [
                {
                  name: this.$t('remittance.balances'),
                  icon: 'mdi-bank',
                  to: { name: 'remittance.balances' },
                },
                {
                  name: this.$t('remittance.balances_self'),
                  icon: 'mdi-bank-outline',
                  to: { name: 'remittance.balances_self' },
                },
                {
                  name: this.$t('remittance.balances_transactions'),
                  icon: 'mdi-bank',
                  to: { name: 'remittance.balances_transactions' },
                },
                {
                  name: this.$t('remittance.balances_self_transactions'),
                  icon: 'mdi-bank-outline',
                  to: { name: 'remittance.balances_self_transactions' },
                },
              ],
            },
            {
              name: this.$t('transactions.transactions'),
              icon: 'mdi-bank-transfer',
              children: [
                {
                  name: this.$t('remittance.balance_transactions'),
                  icon: 'mdi-cash',
                  to: { name: 'remittance.balance_transactions' },
                },
                {
                  name: this.$t('remittance.agency_transactions'),
                  icon: 'mdi-domain',
                  to: { name: 'remittance.agency_transactions' },
                  roles: [Roles.ADMIN],
                },
              ],
            },
          ],
        },
        {
          name: this.$t('messages'),
          icon: 'mdi-message',
          notShow:
            !this.profile ||
            this.profile.parent ||
            !this.profile.services ||
            !this.profile.services.includes(Services.Sms),
          children: [
            {
              name: this.$t('sms.send'),
              icon: 'mdi-plus',
              to: { name: 'sms.send' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('sms.list'),
              icon: 'mdi-format-list-bulleted',
              to: { name: 'sms.list' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('sms.clients'),
              icon: 'mdi-account',
              to: { name: 'sms.clients' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('sms.tags'),
              icon: 'mdi-tag',
              to: { name: 'sms.tags' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('sms.products'),
              icon: 'mdi-message-cog-outline',
              to: { name: 'sms.products' },
              roles: [Roles.ADMIN],
            },
          ],
        },
        {
          name: this.$t('provider'),
          icon: 'mdi-source-repository-multiple',
          roles: [Roles.ADMIN],
          notShow: ![
            Services.Nauta,
            Services.Sms,
            Services.Topup,
          ].filter(item => this.profile.services.includes(item)).length,
          children: [
            {
              name: this.$t('balance'),
              icon: 'mdi-bank-transfer',
              to: { name: 'topup.provider-balance' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('prices'),
              icon: 'mdi-cash-usd',
              to: { name: 'topup.provider-prices' },
              roles: [Roles.ADMIN],
            },
          ],
        },
        {
          name: this.$t('agency.agency'),
          icon: 'mdi-domain',
          children: [
            {
              name: this.$t('announcements'),
              icon: 'mdi-bullhorn',
              to: { name: 'agency-announcements' },
              roles: [Roles.ADMIN],
            },
            {
              name: this.$t('clients'),
              icon: 'mdi-clipboard-account-outline',
              to: { name: 'agency-clients' },
              roles: ['ADMIN', 'EMPLOYEE'],
            },
            {
              name: this.$t('daughters'),
              icon: 'mdi-file-tree',
              to: { name: 'agency-daughters' },
              roles: [Roles.ADMIN, Roles.EMPLOYEE],
            },
            {
              name: this.$t('users'),
              icon: 'mdi-account',
              to: { name: 'agency-users' },
              roles: ['ADMIN', 'AGENT'],
            },
            {
              name: this.$t('topup.agent-prices'),
              icon: 'mdi-cash-usd',
              to: { name: 'topup.agent-prices' },
              roles: ['ADMIN', 'AGENT'],
              notShow: ![
                Services.Nauta,
                Services.Sms,
                Services.Topup,
              ].filter(item => this.profile.services.includes(item)).length,
            },
            {
              name: this.$t('agency.payment_list'),
              icon: 'mdi-currency-usd',
              to: { name: 'agency.payment_list' },
              roles: ['ADMIN', 'AGENT', 'ACCOUNTANT', 'EMPLOYEE'],
              notShow:
                this.profile.parent ||
                (this.profile.role === Roles.EMPLOYEE &&
                  !this.$p.canSeePayments),
            },
            {
              name: this.$t('agency.invoices'),
              icon: 'mdi-receipt',
              to: { name: 'agency.invoices' },
              roles: ['ADMIN', 'ACCOUNTANT'],
            },
          ],
        },
        {
          name: this.$t('agency.transactions'),
          icon: 'mdi-rotate-3d-variant',
          children: [
            {
              name: this.$t('user.user'),
              icon: 'mdi-account',
              to: { name: 'agency.transactions' },
              roles: ['ADMIN', 'AGENT', 'INTEGRATION', Roles.ACCOUNTANT],
            },
            {
              name: this.$t('agency.agency'),
              icon: 'mdi-domain',
              to: { name: 'agency.wholesaler-transactions' },
              roles: ['ADMIN', 'WHOLESALER', Roles.EMPLOYEE],
              notShow:
                this.profile.role === Roles.EMPLOYEE && !this.$p.canSeePayments,
            },
          ],
        },
        {
          name: this.$t('transactions.transactions'),
          icon: 'mdi-bank-transfer',
          children: [
            {
              name: this.$t('transactions.balance_transactions'),
              icon: 'mdi-cash',
              to: { name: 'transactions.balance_transactions' },
            },
            {
              name: this.$t('transactions.funds_transactions'),
              icon: 'mdi-purse',
              to: { name: 'transactions.funds_transactions' },
            },
            {
              name: this.$t('transactions.agency_transactions'),
              icon: 'mdi-domain',
              to: { name: 'transactions.agency_transactions' },
              roles: [Roles.ADMIN],
            },
          ],
        },
        {
          name: this.$t('settings'),
          icon: 'mdi-cogs',
          children: [
            {
              name: this.$t('balance'),
              icon: 'mdi-bank-transfer',
              to: { name: 'transfer-balance' },
              roles: [
                Roles.ADMIN,
                Roles.AGENT,
                Roles.ACCOUNTANT,
                Roles.EMPLOYEE,
              ],
            },
            {
              name: this.$t('preferences'),
              icon: 'mdi-cog-outline',
              to: { name: 'preferences' },
            },
          ],
        },
      ]
    },
  },
  methods: {
    ...mapMutations({ toggle: 'TOGGLE_TOOLBAR' }),
    showItem(item: ListItem): boolean {
      return (
        (!item.children || !!item.children.length) &&
        !item.notShow &&
        this.hasNestedWithSearch(item) &&
        (!item.roles || item.roles.includes(this.profile.role))
      )
    },
    hasNestedWithSearch(item: ListItem): boolean {
      if (
        (item.name as string)
          .toLowerCase()
          .includes((this.search || '').toLowerCase())
      ) {
        return true
      }
      if (item.children) {
        return item.children
          .map(item => this.hasNestedWithSearch(item))
          .includes(true)
      }
      return false
    },
    filterItem(list: ListItem[]): ListItem[] {
      return list.filter(item => {
        if (item.children) {
          item.children = this.filterItem(item.children)
        }
        return this.showItem(item)
      })
    },
    debounce: debounce((vm: any) => {
      vm.filteredItems = vm.filterItem(JSON.parse(JSON.stringify(vm.items)))
      vm.loading = false
    }, 400),
  },
  created() {
    this.filteredItems = this.filterItem(JSON.parse(JSON.stringify(this.items)))
    // const image = localStorage.getItem('drawerBackground');
    // if (image) {
    //   this.image = JSON.parse(image);
    // }
  },
  watch: {
    search() {
      this.loading = true
      this.debounce(this)
    },
  },
})
